import { useEffect } from 'react';

import { useToolPlayControllerContext } from '@/component/Tool/ToolPlayController';
import { VStack, cn, useShortcut } from '@/package';
import { useFrameImageViewer, useLabelingBoxContext } from '@/provider';
import { useToolMenuStore } from '@/store';

import { ToolbarGroup } from './Toolbar';

const TaskLayoutToolbar = () => {
  const { namespace, register, unregister } = useShortcut();
  const { isPlaying, $toolPlayController } = useToolPlayControllerContext();
  const { deselectAll, setAllDisabled } = useToolMenuStore();
  const { selectedLabelingBoxList, selectBoxList } = useLabelingBoxContext();
  const { closeImageWindow } = useFrameImageViewer();

  useEffect(() => {
    register('labeling.toolMenu.deselectAll', () => {
      !selectedLabelingBoxList.length
        ? deselectAll(['editing'])
        : selectBoxList([]);
    });

    return () => {
      unregister('labeling.toolMenu.deselectAll');
    };
  }, [namespace, selectedLabelingBoxList.length]);

  useEffect(() => {
    setAllDisabled(isPlaying);
  }, [isPlaying]);

  useEffect(() => {
    window.addEventListener('beforeunload', closeImageWindow);

    return () => {
      window.removeEventListener('beforeunload', closeImageWindow);
      closeImageWindow();
    };
  }, []);

  return (
    <VStack
      className={cn('h-full w-[42px] bg-gray-200 pt-1')}
      style={{
        paddingBottom: `${($toolPlayController.current?.offsetHeight ?? 0) + 4}px`,
      }}
      items="center"
    >
      <ToolbarGroup.AI />
      <ToolbarGroup.Working />
      <ToolbarGroup.History />

      <div className="flex-1"></div>

      <ToolbarGroup.Camera />
      <ToolbarGroup.Setting />
    </VStack>
  );
};

export default TaskLayoutToolbar;
